const config =  {
  apiEndpoints: {
    accountUri: process.env.VUE_APP_API_URI.concat('auth/'),
    usersUri: process.env.VUE_APP_API_URI.concat('users/'),    
        
    //new
    transactionEntryPointUri: process.env.VUE_APP_API_GATEWAY_URI.concat('transactions/'),
    entriesEntryPointUri: process.env.VUE_APP_API_GATEWAY_URI.concat('entries/'),
    balanceUri: process.env.VUE_APP_API_GATEWAY_URI.concat('transactions/balance/'),

    usersUri: process.env.VUE_APP_API_GATEWAY_URI.concat('customers/users/'),
    bankAccountUri: process.env.VUE_APP_API_GATEWAY_URI.concat('bankAccounts/'),
    
    paymentMethodUri: process.env.VUE_APP_API_GATEWAY_URI.concat('paymentmethods/'),
    paymentMethodTypeUri: process.env.VUE_APP_API_GATEWAY_URI.concat('paymentmethods/'),

    devicesUri: process.env.VUE_APP_API_GATEWAY_URI.concat('devices/'),
    
    paymentLinksUri: process.env.VUE_APP_API_GATEWAY_URI.concat('paymentLinks/'),
    moneyOutUri: process.env.VUE_APP_API_GATEWAY_URI.concat('moneyouts/'),
    withdrawalsUri: process.env.VUE_APP_API_GATEWAY_URI.concat('moneyflows/api/withdrawals/'),
    billPaymentUri: process.env.VUE_APP_API_GATEWAY_URI.concat('moneyflows/api/billpayments/'),
    bankTransferUri: process.env.VUE_APP_API_GATEWAY_URI.concat('moneyflows/api/banktransfers/'),
    pixTransferUri: process.env.VUE_APP_API_GATEWAY_URI.concat('moneyflows/api/pixtransfers/'),
    viaCepUri: process.env.VUE_APP_VIACEP_URI,
    cnaeListUri: process.env.VUE_APP_CNAE_URI,
    bankListUri: process.env.VUE_APP_BANKS_URI
  },
  currentPartnerKey: process.env.VUE_APP_PARTNER_KEY,
  partnersConfiguration: {},
  partnersList: [
    {
      key: 'SEPAG',
      name: 'Sepag',
      apptitle: 'Gestor de Recebíveis',
      images: {
        header: {
          width: 80
        }
      },
      login: {
        type: 'default'
      },
      payments: {
        paymentGroup: {
          enabled: true,
          exportType: 'excel'
        },
        salesPerson: true,

      },
      contracts: {
        exportPdf: false,
        installmentsExpanded: true,
        partnerTaxEnabled: false
      },
      transactions: {
        addCash: true
      },
      banks: {
        useDefault:  false,
        defaultBankCode: 0,
      },
      reports: {
        detailedTransactions: true,
        statement: true,
        receivableTransactions: true,
        showTransactionDetailLink: false
      },
      devices: {
        usage: {
          enabled: true
        },
        rentalCharge: {
          enabled : true
        },
        export: true
      },
      sellers: {
        fakeData: false,
        paymentLink: true,
        statement: false
      }
    },
    {
      key: 'QUADRIPAY',
      name: 'QuadriPay',
      apptitle: 'QuadriPay',
      images: {
        header: {
          width: 120
        }
      },
      login: {
        type: 'default'
      },
      payments: {
        paymentGroup: {
          enabled: true,
          exportType: 'cnab'
        },
        salesPerson: true
      },
      contracts: {
        exportPdf: false,
        installmentsExpanded: true,
        partnerTaxEnabled: false
      },
      transactions: {
        addCash: true
      },
      banks: {
        useDefault:  false,
        defaultBankCode: 0,
      },
      reports: {
        detailedTransactions: true,
        statement: true,
        receivableTransactions: true,
        showTransactionDetailLink: false
      },
      devices: {
        usage: {
          enabled: true
        },
        rentalCharge: {
          enabled : true
        },
        export: true
      },
      sellers: {
        fakeData: true,
        paymentLink: true,
        statement: false
      }
    }
  ],
  currentPartner: function() {
    const self = this;
    return this.partnersList.find(function (el) {
      return el.key == self.currentPartnerKey; 
    });
  }
}

config.partnersConfiguration = config.currentPartner();
export {config as default};

